import { useReactiveVar } from '@apollo/client'

import { MissionReviewMenuDarkImage, MissionReviewMenuImage } from '@local/assets/images'

import { darkModeVar } from '@web/hooks/useGlobalDetermineDarkMode'
import { QAModeVar } from '@web/hooks/useGlobalQAMode'
import nClicks from '@web/libs/nlog/click/codes'

import CompletedMissionCard from '../../MissionCard/CompletedMissionCard'
import NoContent from '../../MissionCard/Content/NoContent'
import ProgressStamp from '../../MissionCard/Content/ProgressStamp/ProgressStamp'
import styles from '../../MissionCard/Content/ProgressStamp/ProgressStamp.module.scss'
import { MissionCard, MissionCardProps } from '../../MissionCard/MissionCard'
import ProgressMissionCard, { ProgressMissionCardProps } from '../../MissionCard/ProgressMissionCard'

interface Props {
  missionCard: MissionCardProps
}

const PlaceCategoryReviewMissionCard = ({ missionCard }: Props) => {
  const isDarkMode = useReactiveVar(darkModeVar)
  const QAMode = useReactiveVar(QAModeVar)

  const Guide = (
    <>
      네이버에 등록된 업종 카테고리를 기준으로 집계됩니다.
      <br />
      <span className={styles.sub_txt}>(예시) 한식, 일식, 중식, 카페&디저트 등</span>
    </>
  )

  const { stampGroups } = missionCard

  const nClickArea: ProgressMissionCardProps['nClickArea'] = {
    openGuide: nClicks.mission.TIPCARD6,
    closeGuide: nClicks.mission.TIPXCARD6,
  }

  // 미션 시작전(미참여)
  if (missionCard.isBeforeStart) {
    return (
      <ProgressMissionCard
        missionCard={missionCard}
        Content={<NoContent image={isDarkMode ? MissionReviewMenuDarkImage : MissionReviewMenuImage} />}
        Guide={Guide}
        nClickArea={nClickArea}
      />
    )
  }

  const firstCompletedMissionStampGroup = MissionCard.getFirstCompleteMissionStampGroup(missionCard)

  // 미션 완료
  if (MissionCard.isCompleteMission(missionCard) && firstCompletedMissionStampGroup) {
    const Content = (
      <ProgressStamp
        countTitle={'리뷰'}
        classname={styles.type_reviewer_of_menu}
        total={missionCard.itemCountToStamp}
        stamps={[
          MissionCard.stampGroupToProgressStampItem(
            firstCompletedMissionStampGroup,
            `리뷰 ${missionCard.itemCountToStamp}번 쓰기 완료`,
          ),
        ]}
      />
    )

    return (
      <CompletedMissionCard
        missionCard={missionCard}
        Content={Content}
        foldable
        nClickArea={{ openMore: nClicks.mission.DONECARD6, closeMore: nClicks.mission.DONEXCARD6 }}
      />
    )
  }
  // 미션 진행중
  else {
    const Content = (
      <ProgressStamp
        countTitle="리뷰"
        classname={styles.type_reviewer_of_menu}
        total={missionCard.itemCountToStamp}
        stamps={missionCard.stampGroups.map(stampGroup =>
          MissionCard.stampGroupToProgressStampItem(stampGroup, `리뷰 ${stampGroup.stamps.length}회`),
        )}
      />
    )

    return <ProgressMissionCard missionCard={missionCard} Guide={Guide} Content={Content} nClickArea={nClickArea} />
  }
}

export default PlaceCategoryReviewMissionCard
